<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i8KofR/tc-custom/scover.jpg?1717896440992" alt="This image is the cover for the book Everything Self-Esteem Book, The Everything Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Self-Esteem Book, The Everything Books
      </h1>
      <p class="bookDescription body article font2">
        <p>If you're looking to completely change how you feel about yourself, <i>The Everything Self-Esteem Book</i> is the perfect guide to help you gain a positive attitude and brim with confidence. Noted speaker and educator Robert M. Sherfield, Ph.D., provides you with encouraging professional advice on how to build self-esteem through developing a positive mindset, defining your personal joys, and learning from and celebrating mistakes.<br/><i>The Everything Self-Esteem Book</i> shows you how to:recognize behavior that reduces self-esteemset goals that workbuild confidence at home and in the workplacefind happiness in all areas of your lifetake positive risksidentify and eliminate people who bring you downand more<br/>Whether you want to overhaul your life and build a positive sense of self-worth or are just preparing for the journey, <i>The Everything Self-Esteem Book</i> is an essential guide to help you realize a healthier life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert M. Sherfield
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?302a7487